import styles from './a3.module.less';

/* eslint-disable-next-line */
export interface A3Props {}

export function A3(props: A3Props) {
  return (
    <div className={styles['container']}>
      <h1>Welcome to A3!</h1>
    </div>
  );
}

export default A3;
